import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgObjectStorageService = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-object-storage-service';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.52 3.282a5.74 5.74 0 0 0-4.598 3.043c-.305.58-.446 1.01-.625 1.905-.012.058-.048.09-.099.09-.362 0-1.258.285-1.83.581-1.571.815-2.64 2.241-3.011 4.019-.07.334-.088.555-.088 1.08s.018.746.088 1.08c.245 1.176.77 2.16 1.587 2.976.813.814 1.774 1.328 2.976 1.592l.42.092h11.32l.42-.092c1.202-.264 2.163-.778 2.976-1.592.817-.816 1.342-1.8 1.587-2.976.07-.334.088-.555.088-1.08s-.018-.746-.088-1.08c-.246-1.178-.771-2.162-1.588-2.976-.793-.791-1.814-1.348-2.863-1.561a3 3 0 0 0-.39-.063c-.051 0-.087-.032-.099-.09-.179-.895-.32-1.325-.625-1.905a5.5 5.5 0 0 0-1.023-1.381 5.69 5.69 0 0 0-4.535-1.662m1.199 1.538a4.23 4.23 0 0 1 3.091 2.32c.308.621.43 1.201.43 2.05v.57h.57c.849 0 1.429.122 2.05.43a4.23 4.23 0 0 1 2.32 3.091c.366 2.079-.878 4.114-2.921 4.774-.578.188-.493.185-6.259.185s-5.681.003-6.259-.185c-1.531-.495-2.646-1.763-2.918-3.317-.327-1.868.606-3.698 2.317-4.548.63-.312 1.188-.43 2.05-.43h.57v-.57q0-.918.208-1.528c.502-1.467 1.771-2.568 3.272-2.839a5 5 0 0 1 1.479-.003M10.24 10v1.76h3.52V8.24h-3.52zm-2.751 3.671L6.198 15.74l1.301.011c.716.005 1.885.005 2.6 0l1.298-.011-1.288-2.068c-.709-1.138-1.298-2.069-1.309-2.07s-.601.931-1.311 2.069m7.555-1.848a2.02 2.02 0 0 0-1.254 1.057c-.164.349-.199.509-.196.92.003.562.211 1.011.659 1.426.785.726 1.973.695 2.739-.073 1.265-1.268.362-3.406-1.43-3.39a2.5 2.5 0 0 0-.518.06"
    })
  }));
});
export default SvgObjectStorageService;